<template lang="pug">
.container.grid-lg
  .has-icon-left.mt-2
    input.form-input(v-model="query", placeholder="Nome do fiscal")
    i.form-icon.fa.fa-fw.fa-search
  v-map.mt-2.map-style(:center="municipioLocal", :zoom="13")
    v-marker(
      v-for="geo in filteredGeos",
      :key="geo.id",
      :position="{ lat: geo.latitude, lng: geo.longitude }",
      :options="{ icon: '/img/pin_red.png' }",
      :info-window="infoWindow(geo)"
    )
</template>

<script>
import usuarioGeos from "@/api/usuarioGeos"
import ApiInfoService from "@/lib/ApiInfoService"
import toastErrors from "@/lib/errors/toastErrors"
import transliterate from "@/lib/transliterate"
export default {
  data() {
    return {
      query: "",
      geos: [],
      municipioLocal: ApiInfoService.getInfo().municipio_local,
    }
  },
  computed: {
    filteredGeos() {
      return this.geos.filter((item) => {
        return transliterate(item.usuario.nome.toLowerCase()).includes(
          transliterate(this.query.toLowerCase()),
        )
      })
    },
  },
  methods: {
    infoWindow(geo) {
      const date = this.$options.filters.date(geo.realizado_em)
      return `
        <div>
          <b>${geo.usuario.nome}</b>
          <div class="mt-1">
            <small>Em: <b>${date}</b></small>
          </div>
          <div class="mt-1">
            <small>
              <a href="/#/app/osm/consultas/usuarios-geos/${geo.usuario.id}" style="box-shadow: none" class="c-hand mt-2">
                <span class="fa fa-eye" />
                Abrir histórico
              </a>
            </small>
          </div>
        </div>
      `
    },
  },
  async created() {
    try {
      this.geos = await usuarioGeos.list()
    } catch (e) {
      toastErrors(e)
    }
  },
}
</script>

<style lang="stylus" scoped>
.map-style {
  height: calc(100vh - 100px);
  border-radius: 10px;
}
</style>
